import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import InvoiceEdit from "./InvoiceEdit";
import { useInvoiceLoader } from "../hooks/InvoiceLoaderHook";
import { createEmptyInvoice } from "../types/CommercialDocumentTypes";

import type { Invoice } from "../types/CommercialDocumentTypes";

export const InvoiceEditPage = () => {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();

	const [invoice, setInvoice] = useState<Invoice>(createEmptyInvoice());
	const [hasInvoice, setHasInvoice] = useState<boolean>(false);

	const { fetchData, loading } = useInvoiceLoader({
		onFetched: (invoice) => {
			setInvoice(invoice);
			setHasInvoice(true);
		},
	});

	useEffect(() => {
		setHasInvoice(false);
		if (id && id !== "new") fetchData(id);
		if (id === "new") {
			setInvoice(createEmptyInvoice());
			setHasInvoice(true);
		}
	}, [id]);

	return (
		<Box
			style={{
				minHeight: "90vh",
				height: "auto",
				width: "100%",
				position: "relative",
			}}>
			{loading ? (
				<Box display="flex" justifyContent="center" alignItems="center" height="100vh">
					<CircularProgress />
				</Box>
			) : hasInvoice ? (
				<InvoiceEdit invoice={invoice} setInvoice={setInvoice} />
			) : (
				<Box textAlign="center">
					<Typography variant="h6">{t("nothing-available")}</Typography>
				</Box>
			)}
		</Box>
	);
};
